var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationOn = function SvgLocationOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.002 11.861q.746 0 1.276-.531t.53-1.278-.532-1.276a1.75 1.75 0 0 0-1.278-.53q-.745 0-1.276.532-.53.531-.53 1.278 0 .745.532 1.276.531.53 1.278.53M12 19.51q2.936-2.628 4.491-5.04 1.557-2.412 1.557-4.226 0-2.735-1.737-4.496T12 3.987 7.69 5.748t-1.738 4.496q0 1.815 1.557 4.226T12 19.51m0 1.996q-3.776-3.271-5.661-6.089-1.887-2.817-1.887-5.173 0-3.462 2.24-5.605Q8.93 2.497 12 2.496T17.31 4.64q2.24 2.144 2.24 5.605 0 2.356-1.887 5.173T12 21.506"
  })));
};
export default SvgLocationOn;